import { createReducer, on } from '@ngrx/store';

import { selectDestinationPlaceAction } from '@shared/base-search-bar/store/actions/search-bar.actions';
import { AutocompletePlace } from '@shared/base-search-bar/entities/autocomplete';
import { loadSearchDataSuccessAction } from '@shared/base-search-bar/store/actions/storage.actions';

export const initialState: AutocompletePlace = {} as AutocompletePlace;

export const destinationPlaceReducer = createReducer(
  initialState,
  on(selectDestinationPlaceAction, (state, { selectedPlace }) => selectedPlace),
  on(loadSearchDataSuccessAction, (state, { data }) => data ? data.destinationPlace : initialState)
);
